import React, { useState } from "react";
import { connect } from "react-redux";
import { isEmpty } from "../../../utilities/methods";
import * as roomRTC from "../../../services/roomRTC";

import "../Chats.css";

const ChatNewMessage = ({ username }) => {
    const [message, setMessage] = useState("");

    const handleTextChanged = (e) => {
        setMessage(e.target.value);
    };

    const handleKeyPressed = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            handleSendMessage();
        }
    };

    const handleSendMessage = async () => {
        if (!isEmpty(message)) {
            roomRTC.sendMessageDataChannel(username, message);
        }
        
        setMessage("");
    };

    return (
        <div className='chat_new_message_container'>
            <div className='input_group_container'>
                <input
                    type="text"
                    value={message}
                    placeholder="Sua mensagem..."
                    onChange={handleTextChanged}
                    onKeyDown={handleKeyPressed}
                    className='form-control input_theme_style'
                />

                <span className="material-symbols-outlined btn_icon_circle"
                    title='Enviar mensagem'>send</span>
            </div>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(ChatNewMessage);